import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import Overlapping from "highcharts/modules/overlapping-datalabels";
import questionResultMain from "models/QuestionResultMain";
import questionResultSub from "models/QuestionResultSub";

Overlapping(ReactHighcharts.Highcharts);

class QuestionResult extends React.Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.dataMain !== this.props.dataMain ||
      nextProps.dataSub !== this.props.dataSub
    );
  }
  render() {
    return (
      <Fragment>
        <div style={{ width: "75%", display: "inline-block", marginRight: 20 }}>
          <ReactHighcharts
            config={questionResultMain(
              this.props.dataMain,
              this.props.category
            )}
          />
        </div>
        <div style={{ width: "20%", display: "inline-block" }}>
          <ReactHighcharts config={questionResultSub(this.props.dataSub)} />
        </div>
      </Fragment>
    );
  }
}

QuestionResult.propTypes = {
  dataMain: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataSub: PropTypes.arrayOf(PropTypes.object).isRequired,
  category: PropTypes.string.isRequired
};

export default QuestionResult;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/QuestionResult.jsx